import { FC, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Tab,
  Tabs,
  tabsClasses,
  Typography,
} from '@material-ui/core';
import { Availability } from 'src/interfaces/new-technician/technician';
import { getDayMonth } from 'src/utils/date-format';
import viewContext from 'src/viewContext';
import { Slot } from 'src/interfaces/repair-request/repair-request';

interface AppointmentSlotProps {
  timeSlots: Availability[];
  setSlotDetails: (data: Slot) => void;
}

export const AppointmentSlot: FC<AppointmentSlotProps> = (props) => {
  const { setSlotDetails, timeSlots } = props;
  const { mobileView } = useContext(viewContext);
  const [selectedDate, setSelectedDate] = useState<Date>(timeSlots[0].date);
  const [slotTime, setSlotTime] = useState<string>('');
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const handleChangeDate = (event, date: Date) => {
    setSelectedIndex(parseInt(event.target.id, 10));
    setSlotTime('');
    setSelectedDate(date);
    setSlotDetails({ date, slot: '' });
  };

  // we need to show only avaliable slots after 6 hours of current time
  const calculateAvailableSlots = (slot: Availability) => {
    let timeNumber = 9;
    const selectedDateData = new Date(slot.date);
    let totalAvailableSlots = slot.available;
    for (let i = 0; i < slot?.slots.length; i++) {
      if (selectedDateData.getDate() === new Date().getDate()
          && selectedDateData.getMonth() === new Date().getMonth()) {
        if (new Date().getHours() + 6 >= timeNumber) {
          totalAvailableSlots -= slot?.slots?.[i].available;
        }
        timeNumber += 3;
      }
    }
    return totalAvailableSlots;
  };

  const renderSlots = () => {
    const result = [];
    const selectedData = timeSlots[selectedIndex];
    let isDisabled;
    let timeNumber = 9;
    const dateSelected = new Date(selectedDate);
    for (let i = 0; i < selectedData?.slots?.length; i++) {
      if (selectedData.slots[i].available >= 1) {
        if (dateSelected.getDate() === new Date().getDate()
        && dateSelected.getMonth() === new Date().getMonth()) {
          // + 6 is added because we need to show only avaliable slots after 6 hours of current time
          if (new Date().getHours() + 6 >= timeNumber) {
            isDisabled = true;
          } else {
            isDisabled = false;
          }
        } else {
          isDisabled = false;
        }
        timeNumber += 3;
      } else if (selectedData.slots[i].available === 0) {
        isDisabled = true;
      }
      result.push(
        <Grid
          key={selectedData.slots[i].slot}
          item
          md={3}
        >
          <Button
            disabled={isDisabled}
            variant={((slotTime === selectedData.slots[i].slot
              && dateSelected))
              ? 'contained' : 'outlined'}
            color="success"
            onClick={() => {
              setSlotTime(selectedData.slots[i].slot);
              setSlotDetails({ date: dateSelected, slot: selectedData.slots[i].slot });
            }}
          >
            { selectedData?.slots[i].slot }
          </Button>
        </Grid>
      );
    }
    return result;
  };
  return (
    <Card
      variant="outlined"
      sx={{ mt: 1 }}
    >
      <CardHeader
        title="Appointment"
      />
      <>
        <CardContent
          sx={{
            justifyItems: 'center',
            // pt: 1,
          }}
        >
          <Typography
            display="flex"
            alignItems="center"
            sx={{
              justifyContent: 'flex-start'
            }}
            variant="subtitle2"
          >
            Select Date
            <Typography
              color="error.main"
            >
              &nbsp;
              *
            </Typography>
          </Typography>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <>
              <Grid
                item
                xs={6}
                maxWidth="220px"
              >
                <Box sx={{ maxWidth: { xs: 220, sm: 480 }, bgcolor: 'background.paper', backgroundColor: 'grey' }}>
                  <Tabs
                    value={selectedDate}
                    onChange={handleChangeDate}
                    variant="scrollable"
                    scrollButtons
                    sx={{
                      [`& .${tabsClasses.scrollButtons}`]: {
                        '&.Mui-disabled': { opacity: 0.3 },
                      },
                    }}
                  >
                    {timeSlots?.map((item, index) => (
                      <Tab
                        key={item.date.toString()}
                        id={index.toString()}
                        label={(
                          <>
                            {getDayMonth(item.date)}
                            <br />
                            <span
                              id={index.toString()}
                              style={{
                                fontSize: '10px',
                                // eslint-disable-next-line no-nested-ternary
                                color: calculateAvailableSlots(item) >= 5 ? 'green' : calculateAvailableSlots(item) ? 'orange' : 'red'
                              }}
                            >
                              {`${calculateAvailableSlots(item)} available`}
                            </span>
                          </>
                          )}
                        value={item.date}
                      />
                    ))}
                  </Tabs>
                </Box>
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
                maxWidth="400px"
              >
                <Box sx={{ maxWidth: { xs: 400, sm: 800 }, bgcolor: 'background.paper' }}>
                  <Grid
                    container
                  >
                    <Grid
                      item
                      xs={12}
                      md={12}
                    >
                      <Typography
                        display="flex"
                        marginLeft="2px"
                        height={50}
                        alignItems="center"
                        sx={{
                          p: '10px',
                          pt: '6px',
                          pl: 0,
                          justifyContent: 'flex-start'
                        }}
                        variant="subtitle2"
                      >
                        Select Time Slot
                        <Typography
                          color="error.main"
                        >
                          &nbsp;
                          *
                        </Typography>
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      ml={mobileView ? 0 : 2}
                    >
                      <Grid
                        container
                        spacing={1}
                      >
                        {renderSlots()}
                      </Grid>
                    </Grid>
                  </Grid>

                </Box>
              </Grid>
            </>
          </Grid>
        </CardContent>
      </>
    </Card>
  );
};

AppointmentSlot.propTypes = {
  timeSlots: PropTypes.array,
  setSlotDetails: PropTypes.func
};
